import {
  buildBaseHeaders,
  handleUrl,
  myHeadersWithTokenContentType,
} from '../global';
import {
  CreateAccountTokenData,
  DetailProps,
  ResetPasswordData,
} from './types';

export const resetPassword = (
  token: string,
  password: FormData
): Promise<DetailProps> => {
  const myHeaders = buildBaseHeaders();
  myHeaders.set('Authorization', `Bearer ${token}`);

  const requestOptions = {
    method: 'PUT',
    headers: myHeaders,
    body: password,
  };
  const baseUrl = handleUrl();
  return fetch(`${baseUrl}/api/V1/reset-password`, requestOptions)
    .then((response) => response.text())
    .then((result) => {
      return JSON.parse(result);
    })
    .catch((error) => new Error(error));
};

export const recoverPasswordEmail = (email: string): Promise<DetailProps> => {
  const myHeaders = buildBaseHeaders();
  myHeaders.set('Content-Type', 'application/json');

  const requestOptions = {
    method: 'GET',
    headers: myHeaders,
  };
  const baseUrl = handleUrl();
  return fetch(
    `${baseUrl}/api/V1/reset-password/${email}?first_access=false`,
    requestOptions
  )
    .then((response) => response.text())
    .then((result) => {
      return JSON.parse(result);
    })
    .catch((error) => new Error(error));
};

export const resetPasswordProto = (
  data: ResetPasswordData
): Promise<DetailProps> => {
  const requestOptions = {
    method: 'PATCH',
    headers: myHeadersWithTokenContentType(),
    body: JSON.stringify(data),
  };
  const baseUrl = handleUrl();
  return fetch(`${baseUrl}/api/V1/proto-mobile/password-reset`, requestOptions)
    .then((response) => response.text())
    .then((result) => JSON.parse(result))
    .catch((error) => new Error(error));
};

export const createAccountResetPassword = (
  token: string
): Promise<CreateAccountTokenData> => {
  const myHeaders = buildBaseHeaders();
  myHeaders.set('Authorization', `Bearer ${token}`);

  const requestOptions = {
    method: 'GET',
    headers: myHeaders,
  };
  const baseUrl = handleUrl();
  return fetch(`${baseUrl}/api/V1/reset-password`, requestOptions)
    .then((response) => response.text())
    .then((result) => JSON.parse(result))
    .catch((error) => new Error(error));
};
